import {
    LOGIN_MFA_REQUESTING,
  } from './constants'
  
// In order to perform an action of type LOGIN_REQUESTING
// we need an email and password
export const loginMfaRequest = function loginMfaRequest (formData, history) {
  return {
    type: LOGIN_MFA_REQUESTING,
    formData,
    history,
  }
}
  
export default loginMfaRequest


// WEBPACK FOOTER //
// ./src/views/Pages/LoginMfa/actions.js